import React from 'react';

import Tooltip from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import runModal from 'ui-library/runModal';
import {ElementMouseEvent} from 'util/Types';

import PrintBarcodeModal from './PrintBarcodeModal';

interface Props {
  buttonSize?: ButtonSize;
  disabled?: boolean;
  buttonStyle: ButtonStyle;
  className?: string;
  itemIds: Array<string>;
  // This callback aims to track user clicks.
  onClickTracking?: () => void;
  shouldAlwaysShowSampleStatusTable?: boolean;
}

export default function PrintLabelButton({
  buttonSize = ButtonSize.SMALL,
  disabled = false,
  buttonStyle,
  className,
  itemIds,
  onClickTracking,
  shouldAlwaysShowSampleStatusTable = false,
}: Props): JSX.Element {
  const handleOpenPrintBarcodeModal = (e: ElementMouseEvent): void => {
    e.stopPropagation();
    onClickTracking?.();
    runModal(PrintBarcodeModal, {itemIds, shouldAlwaysShowSampleStatusTable});
  };

  return (
    <Tooltip title="Print..." disabled={disabled}>
      <Button
        aria-label="Print"
        buttonStyle={buttonStyle}
        className={className}
        disabled={disabled}
        icon="format-print"
        onClick={handleOpenPrintBarcodeModal}
        size={buttonSize}
        dataTestAttrs={{component: 'PrintLabelButton', element: 'button'}}
      />
    </Tooltip>
  );
}
